export default __webpack_public_path__ + "static/header-video-add0e51646c2c960c56fb06f9a97c82f.mp4";